import type { TFunction } from 'i18next';
import { exportType } from '../constants.ts';

export const getExportTypeLabels = (t: TFunction) => {
  return {
    [exportType.OA_MATCH]: t('Identity Graph'),
    [exportType.BIDSTREAM]: t('Bidstream'),
    [exportType.BIDSTREAM_PLUS]: t('Bidstream Plus'),
  } as const;
};
